import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TabsModule } from 'primeng/tabs';

@Component({
  selector: 'app-root',
  imports: [TabsModule, RouterOutlet],
  template: `<router-outlet />`,
  styles: [],
})
export class Root {}
